module.exports = __webpack_public_path__ + "static/media/bali-bombings-social-share-@2x.2d969fc7.png";